(function ($, elementorFrontend) {
	function removeActive(items) {
		items.forEach((element) => {
			$(element.el).removeClass("active");
		});
	}

	function showCaption(items, itemIndex = 0) {
		items.forEach(function (item) {
			setTimeout(() => {
				removeActive(items);
				$(item.el).addClass("active");
			}, item.duration * 1000);
		});
	}

	function init(el) {
		const $cmVideoCaption = $(el);
		const items = $cmVideoCaption.find(".cm-text-slider__item");
		const videoTime = Number($cmVideoCaption.attr("data-video-time"));
		const slides = [];
		$(items).each(function (index, el) {
			const duration = $(el).attr("data-duration") || 0;
			slides.push({
				el: el,
				duration: duration,
			});
		});

		if (videoTime) {
			slides.sort(function (a, b) {
				return a.duration - b.duration;
			});

			showCaption(slides, 0);
			setInterval(() => {
				showCaption(slides, 0);
			}, [videoTime * 1000]);
		}
	}

	$(window).load(function () {
		$(".cm-text-slider").each(function () {
			init($(this));
		});
	});

	class CMVideoCaptionWidget extends elementorModules.frontend.handlers.Base {
		getDefaultSettings() {}
		getDefaultElements() {
			console.log("getDefaultElements");
			return {
				$cmVideoCaption: this.$element.find(".cm-text-slider"),
			};
		}
		bindEvents() {
			console.log("bindEvents");
			init(this.elements.$cmVideoCaption);
		}
	}

	$(window).on("elementor/frontend/init", () => {
		setTimeout(function () {
			const $slides =
				elementorFrontend.elements.$body.find(".cm-text-slider");

			$($slides).each(function () {
				init($(this));
			});

			const addHandler = ($element) => {
				console.log("$element", $element);
				// elementorFrontend.elementsHandler.addHandler(CMVideoCaptionWidget, {
				// 	$element,
				// });
			};

			// elementorFrontend.hooks.addAction(
			// 	"frontend/element_ready/widget",
			// 	($sope) => {
			// 		console.log("sssss", $sope);
			// 	},
			// );
		}, 2000);
	});
})(jQuery, window.elementorFrontend);
